import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Field } from 'react-final-form';
import { toast } from 'react-toastify';
import { Typography, Grid2, useMediaQuery, Divider, Button, TextField } from '@mui/material';

import EditIcon from 'assets/icons/edit-white.svg';

import Layout from 'components/Layout';

import { useTranslation } from 'core/contexts/localization';
import { useMarkup } from 'core/contexts/markups';

import { useStyles } from './styles';

import { Title, TextInput, CircularIndeterminate, SelectComponent } from '@utriper/core-ui';

const MarkupPage = () => {
    const classes = useStyles();
    const history = useHistory();
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const { t: translate } = useTranslation();

    const { getMarkup, loading, addMarkup, updateMarkup, markup, setMarkup } = useMarkup();

    const [markupChanged, setMarkupChanged] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [markupInfo, setMarkupInfo] = useState({});
    const [markupData, setMarkupData] = useState({});

    const locationParam = document.location.href.split('/');
    const markupIndex = locationParam[locationParam.length - 1] ? parseInt(locationParam[locationParam.length - 1]) : false;

    const onSubmit = async (values) => {
        const { status, markupRate } = values;
        if (!values) return;
        try {
            if (markupIndex == 0) {
                const valuesClon = { ...values };
                if (!status) {
                    valuesClon.status = 1;
                }
                if (!markupChanged || !markupRate) {
                    toast.error('Por favor Ingresar al menos un agregado', { position: 'top-right', theme: 'colored' });
                    throw new Error('');
                } else {
                    const newMarkup = await addMarkup(valuesClon);
                    getMarkup(newMarkup.id);
                    history.push(`/markup/${newMarkup.id}`);
                    setCanEdit(false);
                }
            } else {
                const valuesClon = { ...values };
                if (!markupChanged || !markupRate) {
                    toast.error('Por favor Ingresar al menos un agregado', { position: 'top-right', theme: 'colored' });
                    throw new Error('');
                } else {
                    await updateMarkup(valuesClon);
                    setCanEdit(false);
                    getMarkup(markupIndex);
                }
            }
        } catch (err) {
            toast.error(err, {
                position: 'top-right',
                theme: 'colored',
            });
        }
    };

    useEffect(() => {
        setMarkup({});
        if (markupIndex == 0) {
            setCanEdit(true);
        } else {
            getMarkup(markupIndex);
        }
    }, []);

    useEffect(() => {
        setMarkupData(markup);
    }, [markup]);

    return (
        <Layout contentClassName={classes.content}>
            <Title value={'Markup'} />
            <div>
                {loading ? (
                    <CircularIndeterminate />
                ) : (
                    <Grid2>
                        <div className={classes.formContainer}>
                            <Title value={markup?.name} size={'l'} />
                            <Form
                                onSubmit={onSubmit}
                                initialValues={{
                                    ...markupData,
                                }}
                                render={({ handleSubmit, form }) => (
                                    <form id="form" onSubmit={handleSubmit}>
                                        <div>
                                            {markupIndex !== 0 ? (
                                                <>
                                                    <div className={classes.divEditButton}>
                                                        <Typography
                                                            style={{
                                                                fontWeight: 'bold',
                                                                marginBottom: '10px',
                                                            }}
                                                            variant="h5"
                                                            className={classes.text}>
                                                            {'Edit Markup Data'}
                                                        </Typography>
                                                        <Button
                                                            type="button"
                                                            onClick={() => {
                                                                setCanEdit(true);
                                                            }}
                                                            style={{
                                                                height: 40,
                                                                margin: 'inherit',
                                                            }}
                                                            className={classes.editButton}>
                                                            <img src={EditIcon} width={20} />
                                                            {isSmall ? null : <>&nbsp;</>}
                                                            {isSmall ? null : `Edit`}
                                                        </Button>
                                                    </div>

                                                    <Divider />
                                                </>
                                            ) : (
                                                <Typography
                                                    style={{
                                                        fontWeight: 'bold',
                                                        marginBottom: '10px',
                                                    }}
                                                    variant="h5"
                                                    className={classes.text}>
                                                    Crea el agregado:
                                                </Typography>
                                            )}

                                            <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                <Grid2 container direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={3}>
                                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                                        <Field id="id" name="id" component={TextInput} hintText={'Id'} label={'Id'} disabled />
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                                        <Field
                                                            onFieldChange={(value) => {
                                                                markupInfo.start = value;
                                                                setMarkupInfo(markupInfo);
                                                                setMarkupChanged(true);
                                                            }}
                                                            name="start"
                                                            id="start"
                                                            component={TextInput}
                                                            hintText={'Start'}
                                                            label={'Start'}
                                                            disabled={!canEdit}
                                                        />
                                                    </Grid2>
                                                </Grid2>
                                                <Grid2 container direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={3}>
                                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                                        <Field
                                                            onFieldChange={(value) => {
                                                                markupInfo.additional = value;
                                                                setMarkupInfo(markupInfo);
                                                                setMarkupChanged(true);
                                                            }}
                                                            id="additional"
                                                            name="additional"
                                                            component={TextInput}
                                                            hintText={'additional'}
                                                            label={'additional'}
                                                            disabled={!canEdit}
                                                        />
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                                        <Field
                                                            onFieldChange={(value) => {
                                                                markupInfo.end = value;
                                                                setMarkupInfo(markupInfo);
                                                                setMarkupChanged(true);
                                                            }}
                                                            name="end"
                                                            id="end"
                                                            component={TextInput}
                                                            hintText={'End'}
                                                            label={'End'}
                                                            disabled={!canEdit}
                                                        />
                                                    </Grid2>
                                                </Grid2>
                                                <Grid2 container direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={3}>
                                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                                        <Field
                                                            onFieldChange={(value) => {
                                                                markupInfo.createdBy = value;
                                                                setMarkupInfo(markupInfo);
                                                                setMarkupChanged(true);
                                                            }}
                                                            id="createdBy"
                                                            name="createdBy"
                                                            component={TextInput}
                                                            hintText={'createdBy'}
                                                            label={'createdBy'}
                                                            disabled
                                                        />
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                                        <Field
                                                            onFieldChange={(value) => {
                                                                markupInfo.createdOn = value;
                                                                setMarkupInfo(markupInfo);
                                                                setMarkupChanged(true);
                                                            }}
                                                            id="createdOn"
                                                            name="createdOn"
                                                            component={TextInput}
                                                            hintText={'createdOn'}
                                                            label={'createdOn'}
                                                            disabled
                                                        />
                                                    </Grid2>
                                                </Grid2>
                                                <Grid2 container direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={3}>
                                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                                        <Field
                                                            onFieldChange={(value) => {
                                                                markupInfo.updatedBy = value;
                                                                setMarkupInfo(markupInfo);
                                                                setMarkupChanged(true);
                                                            }}
                                                            id="updatedBy"
                                                            name="updatedBy"
                                                            component={TextInput}
                                                            hintText={'updatedBy'}
                                                            label={'updatedBy'}
                                                            disabled
                                                        />
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                                        <Field
                                                            onFieldChange={(value) => {
                                                                markupInfo.updatedOn = value;
                                                                setMarkupInfo(markupInfo);
                                                                setMarkupChanged(true);
                                                            }}
                                                            id="updatedOn"
                                                            name="updatedOn"
                                                            component={TextInput}
                                                            hintText={'updatedOn'}
                                                            label={'updatedOn'}
                                                            disabled
                                                        />
                                                    </Grid2>
                                                </Grid2>
                                                <Grid2 container direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={3}>
                                                    <Grid2 size={{ xs: 12, sm: 6 }} container>
                                                        <Grid2 size={{ xs: 12, sm: 6 }}>
                                                            <Field
                                                                id="status"
                                                                name="status"
                                                                render={({ input, meta }) => (
                                                                    <SelectComponent
                                                                        disabled={!canEdit}
                                                                        {...input}
                                                                        values={[
                                                                            {
                                                                                name: '0',
                                                                                id: '0',
                                                                            },
                                                                            {
                                                                                name: '1',
                                                                                id: '1',
                                                                            },
                                                                        ]}
                                                                        label={'Status (no usar)'}
                                                                        labelId={'status-label'}
                                                                        style={{ width: '100%' }}
                                                                        hasError={meta.touched && !!meta.error}
                                                                        errorMessage={meta.error}
                                                                        onFieldChange={(event) => {
                                                                            input.onChange(event);
                                                                            const value = event.target.value;
                                                                            markupInfo.status = value;
                                                                            setMarkupInfo({
                                                                                ...markupInfo,
                                                                            });
                                                                            setMarkupChanged(true);
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid2>
                                                        <Grid2 size={{ xs: 12, sm: 6 }}>
                                                            <Field id="markupRate" name="markupRate">
                                                                {({ input }) => (
                                                                    <TextField
                                                                        {...input}
                                                                        type="number"
                                                                        variant="outlined"
                                                                        hintText={'markupRate'}
                                                                        label={'markupRate'}
                                                                        disabled={!canEdit}
                                                                        sx={{ width: '100%' }}
                                                                        onChange={(e) => {
                                                                            let value = e.target.value < 0 ? 0 : e.target.value > 1000 ? 1000 : e.target.value;
                                                                            markupInfo.markupRate = value;
                                                                            setMarkupInfo(markupInfo);
                                                                            setMarkupChanged(true);
                                                                            input.onChange(value);
                                                                        }}
                                                                    />
                                                                )}
                                                            </Field>
                                                        </Grid2>
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                                        <Field
                                                            onFieldChange={(value) => {
                                                                markupInfo.cancelReason = value;
                                                                setMarkupInfo(markupInfo);
                                                                setMarkupChanged(true);
                                                            }}
                                                            id="cancelReason"
                                                            name="cancelReason"
                                                            component={TextInput}
                                                            hintText={'cancelReason'}
                                                            label={'cancelReason'}
                                                            disabled={!canEdit || markupIndex == 0}
                                                        />
                                                    </Grid2>
                                                </Grid2>
                                            </div>
                                        </div>

                                        <Grid2 container justifyContent="flex-end" alignContent="flex-end">
                                            <Grid2 container justifyContent={'space-between'} style={{ width: 'auto' }}>
                                                <Button
                                                    className="rounded mr-3 height-40 w-100px"
                                                    disabled={!canEdit}
                                                    type="button"
                                                    onClick={(e) => {
                                                        setCanEdit(false);
                                                        return form.reset(e);
                                                    }}>
                                                    {translate('btn_cancel')}
                                                </Button>

                                                <Button
                                                    onClick={(e) => {
                                                        return handleSubmit(e);
                                                    }}
                                                    className="rounded height-40 w-100px triper-button bg-green-300"
                                                    disabled={!canEdit}
                                                    type="submit">
                                                    {translate('btn_submit')}
                                                </Button>
                                            </Grid2>
                                        </Grid2>
                                    </form>
                                )}
                            />
                        </div>
                    </Grid2>
                )}
            </div>
        </Layout>
    );
};

MarkupPage.displayName = 'MarkupPage';

export default MarkupPage;
